module.exports = __webpack_public_path__ + "static/media/HKG.82b9a7cc.jpg";